import { Fragment, useEffect, useState } from "react";
import {
	useTable,
	useGlobalFilter,
	useFilters,
	useExpanded,
	usePagination,
	useRowSelect,
} from "react-table";
import { Table, Row, Col, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { DefaultColumnFilter } from "../../../Components/Common/filters";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { useSelector } from "react-redux";
import { ApplicationState } from "store";
import Paginator from "Components/Common/Paginator";
import DtsTablePlaceholder from "Components/Common/FormBuilder/DtsTablePlaceholder";

interface TableContainerProps {
	columns?: any;
	data?: any;
	tableClass?: any;
	theadClass?: any;
	isPageSizeChange?: any;
	trClass?: any;
	thClass?: any;
	divClass?: any;
	access?: any;
	props: any;
	onChangePageSize: (e: any) => void;
	pageChanged: (e: any) => void,
	pagination: any;
	pagesList: any;
	setisDeleteOpen: (e: any) => void;
	setRecord: (e: any) => void;
	usersLoading: any;
}
const TableContainer = ({
	columns,
	data,
	isPageSizeChange,
	tableClass,
	theadClass,
	trClass,
	thClass,
	divClass,
	access,
	props,
	setRecord,
	setisDeleteOpen,
	onChangePageSize,
	pageChanged,
	pagination,
	pagesList,
	usersLoading
}: TableContainerProps) => {
	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		page,
		prepareRow,
		setPageSize,
		state: { pageIndex, pageSize },
	} = useTable(
		{
			columns,
			data,
			defaultColumn: { Filter: DefaultColumnFilter },
			initialState: {
				pageIndex: 0,
				pageSize: 1000,
				selectedRowIds: 0,
				sortBy: [
					{
						desc: true,
					},
				],
			},
		},
		useGlobalFilter,
		useFilters,
		useExpanded,
		usePagination,
		useRowSelect
	);
    const navigate = useNavigate();

	const generateSortingIndicator = (column: any) => {
		return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
	};

	const onChangeInSelect = (event: any) => {
		setPageSize(Number(event.target.value));
		onChangePageSize(event.target.value)
	};

	const [view, setView] = useState(false);
	const [edit, setEdit] = useState(false);
	const [deleteaccess, setDeleteAccess] = useState(false);
	const [create, setCreate] = useState(false);
	const userProfile = useSelector((state: ApplicationState) => state.auth.userProfile);

	useEffect(() => {
		let userRole = userProfile?.role?.title;
		if (userRole === "Owner") {
			setView(true)
			setEdit(true)
			setCreate(true)
			setDeleteAccess(true)
		}
		else {
			access && access.length && access.map((item: any, index: any) => {
				if (item.name) {
					switch (item.name) {
						case "View": item.value == "" || item.value == "none" ? setView(false) : setView(true)
							break
						case "Edit": item.value == "" || item.value == "none" ? setEdit(false) : setEdit(true)
							break
						case "Delete": item.value == "" || item.value == "none" ? setDeleteAccess(false) : setDeleteAccess(true)
							break
						case "Create": item.value == "" || item.value == "none" ? setCreate(false) : setCreate(true)
							break
					}
				}

			})
		}
	})

	
    const handleEditClick = (id: string) => {
		navigate(`/users/${id}`);
	};

	return (
		<Fragment>
			{
			!usersLoading ?
			page && page.length > 0?
			<div className={divClass}>
				<Table hover {...getTableProps()} className={tableClass}>
					<thead className={theadClass}>
						{headerGroups.map((headerGroup: any) => (
							<tr
								className={trClass}
								key={headerGroup.id}
								{...headerGroup.getHeaderGroupProps()}
							>
								{headerGroup.headers.map((column: any) => (
									<th
										key={column.id}
										className={thClass}
									>
										{column.render("Header")}
										{generateSortingIndicator(column)}
									</th>
								))}
								<th
										className={thClass}
									>Action</th>
							</tr>
						))}
					</thead>
					<tbody {...getTableBodyProps()}>
						{page.map((row: any) => {
							prepareRow(row);
							return (
								<Fragment key={row.getRowProps().key}>
									<tr>
										{row.cells.map((cell: any) => {
											let classList = cell.column.className;
											return (
												<td
													key={cell.id}
													className={`${classList}`}
													{...cell.getCellProps()}
												>
													{cell.render("Cell")}
												</td>
											);
										})}
										<td>
											<li className="list-inline-item">
												<UncontrolledDropdown>
													<DropdownToggle
														href="#"
														className="btn btn-soft-primary btn-sm dropdown"
														tag="button"
													>
														<i className="ri-more-fill"></i>
													</DropdownToggle>
													<DropdownMenu className="dropdown-menu-end">
														{view ?
															<DropdownItem className="dropdown-item" onClick={() => handleEditClick(row.original.id)}
															>
																<button className="btn btn-sm btn-soft-info remove-list fs-12"
																>
																	<i className="ri-eye-fill"></i>{" "}
																</button>{" "}
																{props.t("common.table.view")}
															</DropdownItem>
															: null}
														{edit ?
															<DropdownItem
																className="dropdown-item edit-item-btn fs-12"
																onClick={() => handleEditClick(row.original.id)}
															>
																<button className="btn btn-sm btn-soft-secondary remove-list"
																>
																	<i className="ri-pencil-fill"></i>{" "}
																</button>{" "}
																{props.t("common.table.edit")}
															</DropdownItem> : null}
														{deleteaccess ? (
															<DropdownItem
																disabled={
																	row.original.id === userProfile?.id ||
																	row.original.role?.title === "Owner"
																}
																onClick={() => {
																	setRecord(row.original);
																	setisDeleteOpen(true);
																}}
															>
																<button className="btn btn-sm btn-soft-danger remove-list"
																>
																	<i className="ri-delete-bin-fill"></i>{" "}
																</button>{" "}
																{props.t("common.table.delete")}
															</DropdownItem>
														) : null}
													</DropdownMenu>
												</UncontrolledDropdown>
											</li>
										</td>
									</tr>
								</Fragment>
							);
						})}
					</tbody>
				</Table>
				<Row className="align-items-center mt-2 g-3 text-center text-sm-start mb-2">
					<div className="col-sm">
						<div className="text-muted">
							{props.t("common.pagination.showing")}
							<span className="fw-semibold ms-1">
							{data.length > 0 ? `${pagination.offset + 1}-${Math.min(pagination.offset + pagination.size, pagination.elements)} of ${pagination.elements} results` : `0-0 of 0 results`}
							</span>
						</div>
					</div> 
					<div className="col-sm-auto">
						<Paginator
							total={pagination && pagination.elements ? pagination.elements : 0}
							currentPage={pagination?.page}
							pageChanged={(e: any) => pageChanged(e)}
							pageSize={pageSize}
							isPageSizeChange={isPageSizeChange}
							onChangeInSelect={(e: any) => onChangeInSelect(e)}
							pagination={pagination}
							props={props}
							pages={pagesList}
						/>
					</div>
				</Row>
			</div>
			: 
			<Row className="text-center">
				<Col>
					<span className="fs-18 fw-semibold">{props.t("common.message.no_users_to_show")}</span>
				</Col>
			</Row>:
			<DtsTablePlaceholder 
					columns={columns} 
					theadClass={theadClass}     
					tableClass="align-middle table-nowrap"
					thClass="border-bottom-1 table-soft-primary"
				/>
			}
		</Fragment>
	);
};

export default TableContainer;
